import CssBaseline from '@mui/material/CssBaseline';
import * as PropTypes from 'prop-types';
import { useState } from 'react';
import Configurator from 'components/Configurator';
import MDBox from 'components/MDBox';
import SidenavPro from 'components/SidenavPro';

export function SidenavLayout({ layout, routes, configsButton, children }) {
  const [menuWidth, setMenuWidth] = useState(80); // largeur par défaut (icônes seules)
  const expandedWidth = 240; // largeur quand menu ouvert

  const handleToggle = (isOpen) => {
    setMenuWidth(isOpen ? expandedWidth : 80);
  };

  return (
    <>
      <CssBaseline />
      {layout === 'dashboard' && (
        <MDBox sx={{ display: 'flex', flex: 1, position: 'relative' }} id="sideNavLayout">
          <MDBox
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              height: '100%',
              zIndex: 1200
            }}
          >
            <SidenavPro routes={routes} onToggle={handleToggle} />
          </MDBox>

          {configsButton}
          <MDBox
            id="outletContainer"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              borderRadius: 0,
              marginLeft: `${menuWidth}px`
            }}
          >
            {children}
          </MDBox>
        </MDBox>
      )}
      {layout === 'vr' && <Configurator />}
    </>
  );
}

SidenavLayout.propTypes = {
  layout: PropTypes.any,
  routes: PropTypes.any,
  configsButton: PropTypes.any,
  children: PropTypes.node.isRequired
};
